import * as React from 'react';
import { CnIcon } from '@/components/cn-icon';
import { StaticFileIcon } from '@/components/cn-oss-upload/components/upload-list-item/icons';
import { CnEllipsis } from '@/components/cn-ellipsis';
import { calcSize, canUseImageViewer, } from '@/components/cn-oss-upload/components/upload-list-item/utils';
import { CnImageViewer } from '@/components/cn-image-viewer';
import { CnBox } from '@/components/cn-box';
export const FormatFile = (props) => {
    const { value, mode } = props;
    if (Array.isArray(value)) {
        if (mode === 'simple') {
            const showNum = 3;
            const hasMore = value.length > showNum;
            return (React.createElement(CnBox, { direction: "row", spacing: 8 },
                value.slice(0, showNum).map((file) => (React.createElement("div", { className: "cn-ui-m-card-items-format-file-ext" },
                    React.createElement(StaticFileIcon, { file: file })))),
                hasMore ? (React.createElement("div", { className: "cn-ui-m-card-items-format-more" },
                    showNum,
                    "+")) : null));
        }
        return (React.createElement("div", { className: "cn-ui-m-card-items-format-file cn-oss-upload-list" }, value.map((file) => (React.createElement("div", { className: "cn-oss-upload-list-item-wrapper" },
            React.createElement("div", { className: "cn-oss-upload-list-item-content", onClick: (e) => {
                    e.stopPropagation();
                    const src = file.url;
                    if (canUseImageViewer(file)) {
                        CnImageViewer.open({ src });
                        return;
                    }
                    if (src)
                        window.open(src);
                } },
                React.createElement("div", { className: "cn-oss-upload-list-item-file-ext" },
                    React.createElement(StaticFileIcon, { file: file })),
                React.createElement("div", { className: "cn-oss-upload-list-item-info" },
                    React.createElement(CnEllipsis, { className: "cn-oss-upload-list-item-info-name", ellipsisPosition: "middle", endCharCount: 4, hasTooltip: false }, file.name),
                    file.size ? (React.createElement("div", { className: "cn-oss-upload-list-item-info-size" },
                        "(",
                        calcSize(file.size),
                        ")")) : null)),
            React.createElement("div", { onClick: (event) => {
                    event.stopPropagation();
                    window.open(file.downloadUrl || file.url);
                }, className: "cn-oss-upload-list-item-actions-item" },
                React.createElement(CnIcon, { type: "download", size: "small" })))))));
    }
    return React.createElement(React.Fragment, null, "- -");
};
